import VVSTable from "components/form-control/VVSTable";
import React from "react";
import { Container } from "reactstrap";

export default function InvestmentPackage() {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <VVSTable title="Gói đầu tư" name="ProductInvestment" />
        </Container>
      </div>
    </React.Fragment>
  );
}
